<template>
    <div>
        <div class="clearfix">
            <div class="search-container primary fr mb10">
                <div class="form-box">
                    <input class="input-field" v-model="filterItems.name" placeholder="资质名称"/>
                    <button class="search-btn" @click="getQualiTypeList()"><i class="icon iconfont icon-search"></i></button>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <div v-if="multiSelect" class="table-layout">
                <el-table ref="tableList" :data="qualiTypeList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="multiSelect" type="selection" align="center" width="55"></el-table-column>
                    <el-table-column prop="name" label="资质名称" align="left"></el-table-column>
                    <el-table-column prop="kindNmme" label="资质类型" align="left"></el-table-column>
                    <el-table-column prop="code" label="资质编码" align="center"></el-table-column>
                    <el-table-column prop="desc" label="描述" align="left"></el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table ref="tableList" :data="qualiTypeList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : hasCheckedRow(rows.row)}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="资质名称" align="center"></el-table-column>
                    <el-table-column prop="kindNmme" label="资质类型" align="left"></el-table-column>
                    <el-table-column prop="code" label="资质编码" align="center"></el-table-column>
                    <el-table-column prop="desc" label="描述" align="center"></el-table-column>
                </el-table>
            </div>
            <!--<div class="block pagination-layout">-->
            <!--<el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-quali-type-select',
        desc: '资质类型-选择',
        props: {
            multiSelect: {
                type: Boolean,
                default: true
            },
            //单选初始选择项
            initCheckedItem: {
                type: Object,
                default: null
            },
            //多选初始选择项
            initCheckedItems: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            //资质类型对应的商户类型
            merchantType: {
                type: Number
            }
        },
        data: function () {
            return {
                //分页信息（暂时没有分页）
//                pageNumber: 1,
//                totalCount: 0,
//                pageSize: null,
//                pageSizes: getDefaultPageSizes(),

                //恢复选择延时毫秒数
                checkedDelay: 300,
                //是否正在恢复选择状态
                checkedIniting: false,
                //列表数据标识列名称
                checkedIdProp: 'id',
                checkedNameProp: 'name',
                checkedKindProp: 'kind',
                //列表vue组件id(ref)
                checkedTblId: 'tableList',
                //所有选中的条目id
                checkedItemIds: [],
                //所有选中的条目id => object
                checkedItemMap: {},

                //查询条件
                filterItems: {
                    name: null
                },

                //
                qualiTypeList: []
            }
        },
        created: function () {
            //
            //this.pageSize = this.pageSizes.first();
            //
            let self = this;

            //

            //
            if(this.multiSelect == true) {
                self.initCheckedItems.forEach(function (item) {
                    self.checkedItemIds.add(item.id);
                    //
                    self.checkedItemMap[item.id + ''] = merge({}, item);
                });
            }
            else {
                if(self.initCheckedItem != null) {
                    let item = self.initCheckedItem;
                    //
                    self.checkedItemIds.add(item.id);
                    //
                    self.checkedItemMap[item.id + ''] = merge({}, item);
                }
            }
            //
            self.getQualiTypeList();
        },
        methods: {
            asResultItem(srcItem){
                return {
                    id: srcItem[this.checkedIdProp],
                    kind: srcItem[this.checkedKindProp],
                    name: srcItem[this.checkedNameProp]
                };
            },
            //item 接口信息
            addCheckItem: function (item, val) {
                let id = item.id;
                if(!this.multiSelect) {
                    this.checkedItemIds = [];
                    this.checkedItemMap = {};
                }
                //
                if(!this.checkedItemIds.contains(id)) {
                    this.checkedItemIds.add(id);
                    //
                    this.checkedItemMap[id + ''] = item;
                    //
                    return item;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedItemIds.contains(id)) {
                    self.checkedItemIds.remove(id);
                    //
                    delete this.checkedItemMap[id + ''];
                    //
                    return id;
                }
                return null;
            },

            handleCurrentChange: function (val) {
                this.handleSelectionChange([val]);
            },

            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                //列表对应的数据源
                let tableListItems = self.qualiTypeList;
                //
                let allIds = tableListItems.pluck(self.checkedIdProp);
                let selIds = [];
                selRows.forEach(function (row, index) {
                    let item = self.asResultItem(row);
                    selIds.add(item.id);
                    //
                    let effectItem = self.addCheckItem(item);
                    //
                });

                let lessIds = Utils.compareArrays(selIds, allIds)["less"];
                lessIds.forEach(function (id, index) {
                    let effectId = self.delCheckId(id);
                    //
                });
            },
            restoreSelRows(dataRows){
                let self = this;
                self.checkedIniting = true;
                let allIds = dataRows.pluck(this.checkedIdProp);
                let selIds = Utils.compareArrays(allIds, this.checkedItemIds)["same"];
                if(self.multiSelect) {
                    selIds.forEach(function (id) {
                        self.toggleListRowById(dataRows, id);
                    });
                }
                //
                setTimeout(function () {
                    self.checkedIniting = false;
                }, 100);
            },
            hasCheckedRow(row){
                let checkId = row[this.checkedIdProp];
                return this.checkedItemIds.contains(checkId);
            },
            toggleListRowById(dataRows, idVal){
                let self = this;
                //
                let refTbl = self.$refs[self.checkedTblId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[self.checkedIdProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },

            //分页事件
//            handleSizeChange: function (val) {
//                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
//                this.pageSize = val;
//                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
//                //
//                this.handlePageChange(newPageNumber);
//            },
//            handlePageChange: function (val) {
//                if(this.checkedIniting) {
//                    return;
//                }
//                else {
//                    this.checkedIniting = true;
//                }
//                //
//                this.pageNumber = val;
//                //
//                this.getQualiTypeList();
//            },

            getQualiTypeList: function () {
                let self = this;
                //
//                let postData = {};
//                postData.pagination = {
//                    pageSize: self.pageSize,
//                    pageNumber: self.pageNumber,
//                };

                let filterItems = {
                    merchantType: self.merchantType
                };
                if(!Utils.isNoB(self.filterItems['name'])) {
                    filterItems.name = self.filterItems['name'];
                }
                let loading = MsgBox.loading();
                merchtComnApi.getQualiTypeListBymerchantType(filterItems, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let resultData = result.data;
                        //
//                        let pagination = resultData.pagination;
//                        self.totalCount = pagination.totalCount;
//                        self.pageNumber = pagination.pageNumber;
//                        self.pagesize = pagination.pageSize;
//                        //
//                        self.qualiTypeList = resultData.rows;
                        let qualiTypeList = resultData || [];

                        for(let i = 0;i<qualiTypeList.length;i++){
                            let qualiType = qualiTypeList[i];
                            qualiType.kindNmme = getEnumInfoWith('qualiKind','value',qualiType.kind).text;
                        }
                        self.qualiTypeList = qualiTypeList;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.qualiTypeList);
                        }, self.checkedDelay);
                    } else {
                        MsgBox.failure(result.message);
                    }
                });
            },

            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let multiSelect = self.multiSelect;
                if(multiSelect) {
                    result.data = self.checkedItemIds.map(function (id) {
                        return self.checkedItemMap[id + ''];
                    });

                } else {
                    let checkedItemId = self.checkedItemIds.first();
                    if(checkedItemId != null) {
                        result.data = this.checkedItemMap[checkedItemId + ''];
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/quali/QualiTypeSelect.vue